<div class="toast-container" aria-live="assertive" aria-atomic="true">
  @for (toast of toasts(); track toast.id) {
    <div class="toast" [class.toast--success]="toast.kind === 'success'" [class.toast--error]="toast.kind === 'error'">
      <span>{{ toast.message }}</span>
      <button
        class="toast__close"
        type="button"
        (click)="dismiss(toast.id)"
        [attr.aria-label]="'common.accessibility.dismissNotification' | translate"
      >
        &times;
      </button>
    </div>
  }
</div>
